<template>
  <div class="pa-4">
    <p class="text-body-2 text--secondary mb-4">{{ $t('onboarding.pending-orders.explained') }}</p>
    <order-queue :organization-id="organizationId" embedded />
  </div>
</template>

<script>
import OrderQueue from '@pages/Onboarding/Queue/OrderQueue.vue'

/**
 * Les commandes en attente de l'organisation, dans les mêmes files que l'écran général : ce que le gestionnaire a à
 * faire (valider, remettre des badges) en tête, puis ce qui attend ZEborne, un technicien ou la personne.
 */
export default {
  name: 'OrganizationPendingOrders',

  components: { OrderQueue },

  computed: {
    organizationId() {
      return this.$route.params.id
    },
  },
}
</script>
